import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import repeatElement from '@gik/core/utils/repeatElement';
import { UISize, UIVariant } from '@gik/ui/types';

export interface IIndicatorProps
  extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLUListElement>, HTMLUListElement> {
  currentStep: number;
  totalSteps: number;
  variant?: UIVariant;
  size?: UISize;
  className?: string;
}

const blockName = 'indicator';

export default function Indicator({
  currentStep,
  totalSteps,
  variant = 'default',
  size = 'base',
  className,
  ...otherProps
}: IIndicatorProps) {
  const bem = bemBlock(blockName);

  if (totalSteps > 1) {
    return (
      <ul className={bem(null, [{ [variant]: true }, { [size]: true }], className)} {...otherProps}>
        {repeatElement(totalSteps, i => (
          <li className={bem('step', [{ active: currentStep === i }])} />
        ))}
      </ul>
    );
  } else {
    return null;
  }
}
